<template>
    <div class="page_menu flex-col">
        <div class="group_1 flex-col">
            <div class="group_2 flex-row">
                <img
                        @click="goto('')"
                        class="image_2"
                        referrerpolicy="no-referrer"
                        src="../../assets/header/logo.png"
                />
                <div class="block_1 flex-col"></div>
                <div class="text-wrapper_17 flex-col justify-between">
                    <span class="text_1">北京康柏汉森医药科技咨询有限责任公司</span>
                    <span class="text_2">Beijing&nbsp;Comprehensive&nbsp;Pharmaceutical&nbsp;Consulting&nbsp;Co.,Ltd.</span>
                </div>

                <!-- 导航菜单 -->
                <div class="nav-item_split"></div>
                <div
                        class="nav-item"
                        v-for="(item, index) in menuItems"
                        :key="index"
                        @mouseenter="handleMouseEnter(index)"
                        @mouseleave="handleMouseLeave"
                        @click="handleItemClick(index,item)"
                        :class="{ active: activeIndex === index }"
                >
                    <div class="menu-main">
                        <span class="menu-label">{{ item.label }}</span>
                        <div class="underline" :class="{ active: activeIndex === index }"></div>
                    </div>

                    <!-- 二级菜单 -->
                    <transition name="fade">
                        <div
                                class="submenu"
                                v-show="activeIndex === index && submenuVisible "
                                v-if="item.subItems && item.subItems.length > 0"
                                @mouseenter="handleSubmenuEnter(index)"
                                @mouseleave="handleSubmenuLeave"
                        >
                            <div
                                    class="submenu-item"
                                    v-for="(subItem, subIndex) in item.subItems"
                                    :key="subIndex"
                                    @click.stop="gotoSub(subItem.href)"
                            >
                                <a  class="submenu-link">{{ subItem.label }}</a>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            defaultActiveIndex: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                constants: {},
                menuItems: [
                    {
                        label: '首页',
                        href:'home',
                        menuClass:'nav1',
                        subItems: [],
                    },
                    {
                        label: '走进康柏',
                        href:'about',
                        menuClass:'nav2',
                        subItems: [
                            { label: '关于我们', href: 'about#introduce-section' },
                            { label: '企业荣誉', href: 'about#honor-section' },
                            { label: '行业价值', href: 'about#value-section' },
                            { label: '服务优势', href: 'about#server-section' },
                        ],
                    },
                    {
                        label: '核心业务',
                        href:'Advisory',
                        menuClass:'nav3',
                        subItems: [
                            { label: '渠道风控管理', href: 'Advisory' },
                            { label: '业务合规管理', href: 'compliance' },
                            { label: '企业健康咨询', href: 'consultation' },
                        ],
                    },
                    {
                        label: '新闻中心',
                        href:'Information',
                        menuClass:'nav4',
                        subItems: [
                            { label: '康柏动态', href: 'dynamics' },
                            { label: '行业观察', href: 'observation' },
                        ],
                    },
                    {
                        label: '联系我们',
                        href:'contact',
                        menuClass:'nav5',
                        subItems: [
                            { label: '联系我们', href: 'contact' },
                            { label: '加入我们', href: 'join' },
                        ],
                    },
                ],
                isActiveIndex: null,
                activeIndex: this.defaultActiveIndex,
                defaultIndex: this.defaultActiveIndex,
                submenuVisible: false, // 新增控制二级菜单显示的状态

            };
        },
        watch: {
            // 监听props变化
            defaultActiveIndex(newVal) {
                this.defaultIndex = newVal;
                this.activeIndex = newVal;
            }
        },
        methods: {
            handleMouseEnter(index) {
                this.activeIndex = index;
                this.submenuVisible = true;
            },
            handleMouseLeave() {
                this.submenuVisible = false; // 隐藏二级菜单
                this.activeIndex = this.defaultActiveIndex;
                console.log(this.defaultActiveIndex)
            },
            handleItemClick(index,item) {
                this.goto(item.href)
            },

            handleSubmenuEnter() {
               // this.keepOpen = true;
            },
            handleSubmenuLeave() {
                this.keepOpen = false;
               // this.activeIndex = this.defaultIndex;
            },
            // 辅助方法，用于滚动到指定的锚点
            scrollToAnchor(anchor) {
                const element = document.getElementById(anchor);
                if (element) {
                    // 使用 scrollIntoView 平滑滚动到目标元素
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            },
            goto(url){
                url = '/' + url;
                if (url.includes('#')) {
                    let check = url.split('#')[0];
                    if (this.$route.path === check){
                        this.scrollToAnchor(url.split('#')[1]);
                    }else{
                        this.$router.push(url).then(() => {
                            this.scrollToAnchor(url.split('#')[1]);
                        });
                    }
                } else {
                    if (this.$route.path !== url){
                        this.$router.push(`${url}`).then(() => {
                            window.scrollTo(0, 0);
                        });
                    }else{
                        window.scrollTo(0, 0);
                    }
                }
            },
            gotoSub(url){
                this.submenuVisible = false;
                url = '/' + url;
                if (url.includes('#')) {
                    this.$router.push(url).then(() => {
                        this.scrollToAnchor(url.split('#')[1]);
                    });
                } else {
                    if (this.$route.path !== url){
                        this.$router.push(`${url}`).then(() => {
                            window.scrollTo(0, 0);
                        });
                    }else{
                        window.scrollTo(0, 0);
                    }
                }
            },

        }
    };
</script>

<style scoped lang="css"  >
    .page_menu {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 100%;
        height: 76px;
        margin: 0 auto;
    }


    .group_1 {
        background-color: rgba(255, 255, 255, 1);
        border-radius: 6px;
        width: 100%;
        position: absolute;
        left: 0;
        top: 30px;
    }

    .group_2 {
        box-shadow: inset 0px -1px 0px 0px rgba(232, 232, 232, 1);
        background-color: rgba(255, 255, 255, 1);
        width: 100%;
        height: 76px;
        margin-top: -30px;

        display: flex;
        align-items: center;
    }

    .image_2 {
        cursor: pointer;
        width: 117px;
        height: 46px;
        margin: 0 0 0 134px;
    }

    .block_1 {
        background-color: rgba(0, 153, 145, 0.35);
        width: 1px;
        height: 27px;
        margin: 0 0 0 10px;
    }

    .text-wrapper_17 {
        width: 327px;
        height: 41px;
        margin: 0 0 0 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .text_1 {
        width: 315px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: NaN;
        text-align: left;
        line-height: 19px;
        font-size: clamp(12px, 1.2vw, 17px);
        white-space: normal;
    }

    .text_2 {
        width: 327px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: NaN;
        text-align: left;
        line-height: 19px;
        margin-top: 1px;

        font-size: clamp(8px, 0.8vw, 11px);
        white-space: normal;
    }

    .nav-item_split {
        position: relative;
        margin: 24px 0 0 30px;
        padding: 0 24px;
        cursor: pointer;
        z-index: 1000;
    }

    .nav-item {
        position: relative;
        height: 100%; /* 撑满父容器高度 */
        display: flex; /* 启用flex布局 */
        align-items: center; /* 垂直居中 */
        /*padding: 0 24px;*/
        padding: 0 1.5vw;
        cursor: pointer;
        z-index: 1000;
        margin: 0; /* 移除原来的margin-top */
    }


    /* 菜单间隔线实现 */
    .nav-item:not(:last-child)::after {
        content: "";
        position: absolute;
        right: 0;
        /*top: 30%;*/
        transform: translateY(0%);
        height: 24px;
        width: 1px;
        background: #ADADAD;
        transition: background 0.3s;
    }

    /* 菜单悬停时改变间隔线颜色 */
    .nav-item:hover:not(:last-child)::after {
        background: #008683;
    }

    .menu-main {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .menu-label {
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 18px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: normal;
        padding: 8px 12px;
        transition: all 0.3s ease; /* 简写过渡属性并添加ease效果 */
        line-height: 28px; /* 确保固定高度 */
        display: inline-block; /* 保证尺寸变化不影响布局 */
    }

    /* 悬停和激活状态样式 */
    .nav-item:hover .menu-label {
        color: rgba(37, 37, 37, 1) !important;
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        /* 以下属性保持过渡动画平滑 */
        transform: translateZ(0); /* 触发硬件加速 */
    }
    .nav-item.active .menu-label {
        color: rgba(37, 37, 37, 1) !important;
        font-size: 20px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        /* 以下属性保持过渡动画平滑 */
        transform: translateZ(0); /* 触发硬件加速 */
    }

    .nav-item:hover .submenu {
        display: block; /* hover时显示 */
    }


    .underline {
        position: absolute;
        bottom: -4px;
        width: 0;
        height: 3px;
        background: #008683;
        transition: all 0.3s;
    }

    .underline.active {
        width: 70%;
    }

    /* 二级菜单样式 */
    .submenu {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%; /* 继承父容器宽度 */
        min-width: 100%; /* 确保最小宽度与父容器一致 */
        background: white;
        box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
        background-color: rgba(255, 255, 255, 1);
        border-radius: 4px;
        padding: 8px 0;

        display: none; /* 默认隐藏 */
    }

    .submenu-item {
        position: relative;
        display: flex;                /* 新增：启用 flex 布局 */
        align-items: center;           /* 新增：垂直居中 */
        justify-content: center;       /* 新增：水平居中 */
        background-color: rgba(255, 255, 255, 1);
        padding: 8px 16px;
        height: 30px;
        z-index: 1000;
        transition: background 0.2s;
    }

    /* 添加底部阴影线（非最后一项） */
    .submenu-item:not(:last-child)::after {
        content: "";
        position: absolute;
        left: 8%; /* 左右各留5%空白 */
        right: 8%;
        bottom: 0;
        height: 1px;
        transition: background 0.2s;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px -1px 0px 0px rgba(232, 232, 232, 1);
    }

    /* 移除最后一个子项的阴影 */
    .submenu-item:last-child {
        box-shadow: none;
    }

    .submenu-item:hover {
        background: #f8f8f8;
    }

    .submenu-link {
        height: 48px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 14px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 48px;

        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0;
    }

    .submenu-link:hover {
        color: rgba(0, 134, 131, 1) !important;
    }

    /* 动效 */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s, transform 0.3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
        transform: translateY(-10px);
    }

    /* 核心业务样式 */
    .service-item {
        padding: 12px 24px;
        font-size: 16px;
        color: #333;
        border-bottom: 1px solid #eee;
    }

</style>
